export default function ActionThreeDotIcon() {
  return (
    <>
      <svg
        width="19"
        height="18"
        viewBox="0 0 19 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.5 14.3438C9.96599 14.3438 10.3438 13.966 10.3438 13.5C10.3438 13.034 9.96599 12.6562 9.5 12.6562C9.03401 12.6562 8.65625 13.034 8.65625 13.5C8.65625 13.966 9.03401 14.3438 9.5 14.3438Z"
          fill="#5E718D"
        />
        <path
          d="M9.5 9.84375C9.96599 9.84375 10.3438 9.46599 10.3438 9C10.3438 8.53401 9.96599 8.15625 9.5 8.15625C9.03401 8.15625 8.65625 8.53401 8.65625 9C8.65625 9.46599 9.03401 9.84375 9.5 9.84375Z"
          fill="#5E718D"
        />
        <path
          d="M9.5 5.34375C9.96599 5.34375 10.3438 4.96599 10.3438 4.5C10.3438 4.03401 9.96599 3.65625 9.5 3.65625C9.03401 3.65625 8.65625 4.03401 8.65625 4.5C8.65625 4.96599 9.03401 5.34375 9.5 5.34375Z"
          fill="#5E718D"
        />
        <path
          d="M9.5 14.3438C9.96599 14.3438 10.3438 13.966 10.3438 13.5C10.3438 13.034 9.96599 12.6562 9.5 12.6562C9.03401 12.6562 8.65625 13.034 8.65625 13.5C8.65625 13.966 9.03401 14.3438 9.5 14.3438Z"
          stroke="currentColor"
          stroke-width="0.4"
        />
        <path
          d="M9.5 9.84375C9.96599 9.84375 10.3438 9.46599 10.3438 9C10.3438 8.53401 9.96599 8.15625 9.5 8.15625C9.03401 8.15625 8.65625 8.53401 8.65625 9C8.65625 9.46599 9.03401 9.84375 9.5 9.84375Z"
          stroke="currentColor"
          stroke-width="0.4"
        />
        <path
          d="M9.5 5.34375C9.96599 5.34375 10.3438 4.96599 10.3438 4.5C10.3438 4.03401 9.96599 3.65625 9.5 3.65625C9.03401 3.65625 8.65625 4.03401 8.65625 4.5C8.65625 4.96599 9.03401 5.34375 9.5 5.34375Z"
          stroke="currentColor"
          stroke-width="0.4"
        />
      </svg>
    </>
  );
}
